import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default function isSenderImageEnabled() {
    return !getIsBitSet(8 /* HideSenderImage */);
}
//# sourceMappingURL=isSenderImageEnabled.js.map